<div class="payment-result-container">
  <div class="payment-result-card cancel">
    <div class="icon-container">
      <i class="lni lni-cross-circle"></i>
    </div>
    <h2>{{ 'PAYMENT.CANCEL_TITLE' | translate }}</h2>
    <p>{{ 'PAYMENT.CANCEL_MESSAGE' | translate }}</p>
    <div class="button-group">
      <button 
        class="btn btn-primary try-again-btn" 
        (click)="tryAgain()">
        {{ 'PAYMENT.TRY_AGAIN' | translate }}
      </button>
      <button 
        class="btn btn-secondary back-btn" 
        (click)="goToDocuments()">
        {{ 'PAYMENT.BACK_TO_DOCUMENTS' | translate }}
      </button>
    </div>
  </div>
</div> 